export const typeLanguage = [
	{
		key: "en",
		text: "English",
		icon: "uk",
		value: "en"
	},
	{
		key: "th",
		text: "ภาษาไทย",
		icon: "th",
		value: "th"
	}
]
